import {Button, LinkButton} from '@components/common/button/button'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {YamlEditor} from '../yaml-editor'
import {popupStore} from './workflow-popup-store'

export const WorkflowEditor = observer(() => {
  const workflow = popupStore.state.editedWorkflow
  const cancel = () => popupStore.stopEditing()
  const save = () => popupStore.save()
  const onChange = (value: string) => {
    popupStore.state.editedWorkflow.config = value
  }
  if (!workflow.config) {
    workflow.config = popupStore.defaultConfig
  }
  return (
    <>
      <TwEditorContainer>
        <YamlEditor value={workflow.config} onChange={onChange} />
      </TwEditorContainer>
      <TwEditorFooter>
        <LinkButton onClick={cancel}>{Lang.msg.cancel}</LinkButton>
        <Button onClick={save} className="px-32 ml-32">
          {Lang.msg.save}
        </Button>
      </TwEditorFooter>
    </>
  )
})

const TwEditorContainer = tw.div`
  absolute
  top-64
  left-0
  w-full
  bottom-64
  max-h-full
`

const TwEditorFooter = tw.div`
  absolute
  bottom-0
  h-64
  left-0
  w-full
  bg-header-old
  flex
  items-center
  justify-center
  border-main-old
  border-t-1
  border-solid
  border-0
`
